export default "__VITE_ASSET__DOTSEirX__"